import plugin_vue3_nC6MxfhBcm from "/app/node_modules/.pnpm/@pinia+nuxt@0.5.1_rollup@3.18.0_typescript@5.0.2_vue@3.5.12_typescript@5.0.2__webpack-sources@3.2.3/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import unhead_2jNkKcpfzG from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import vueuse_head_polyfill_qfwqVnhxrS from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/head/runtime/plugins/vueuse-head-polyfill.js";
import router_1KY28mxwvy from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_DZxtIpFg4o from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import storyblok_gI9Ux4sin1 from "/app/src/modules/storyblok/plugins/storyblok.ts";
import mount_plugin_client_sldIXckK75 from "/app/node_modules/.pnpm/nuxt-delay-hydration@1.1.4_rollup@3.18.0_webpack-sources@3.2.3/node_modules/nuxt-delay-hydration/dist/runtime/mount-plugin.client.mjs";
import unocss_MzCDxu9LMj from "/app/.nuxt/unocss.mjs";
import chunk_reload_client_0EbPTa53x8 from "/app/node_modules/.pnpm/nuxt@3.3.1_@types+node@18.15.7_eslint@8.36.0_optionator@0.9.4_rollup@3.18.0_sass@1.60.0_c7790f775ef7ee098c2326bd893577f4/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import draggable_client_Wa5PLSqOHq from "/app/src/plugins/draggable.client.ts";
import firebase_client_lOvfsw6Ppv from "/app/src/plugins/firebase.client.ts";
import image_kit_6XFwpsv9OT from "/app/src/plugins/image-kit.ts";
import masonry_wall_R3IkmABGyf from "/app/src/plugins/masonry-wall.ts";
import popper_uNmHSnnDKH from "/app/src/plugins/popper.ts";
import quill_client_Wqv6ADGlry from "/app/src/plugins/quill.client.ts";
import swiper_client_uDPQhOjmYM from "/app/src/plugins/swiper.client.ts";
import toast_client_5GxzM6P4QL from "/app/src/plugins/toast.client.ts";
import vue_query_JC9gnf7CA1 from "/app/src/plugins/vue-query.ts";
import wasLoggedIn_client_M31qqvBN1l from "/app/src/plugins/wasLoggedIn.client.ts";
export default [
  plugin_vue3_nC6MxfhBcm,
  components_plugin_KR1HBZs4kY,
  unhead_2jNkKcpfzG,
  vueuse_head_polyfill_qfwqVnhxrS,
  router_1KY28mxwvy,
  prefetch_client_DZxtIpFg4o,
  storyblok_gI9Ux4sin1,
  mount_plugin_client_sldIXckK75,
  unocss_MzCDxu9LMj,
  chunk_reload_client_0EbPTa53x8,
  draggable_client_Wa5PLSqOHq,
  firebase_client_lOvfsw6Ppv,
  image_kit_6XFwpsv9OT,
  masonry_wall_R3IkmABGyf,
  popper_uNmHSnnDKH,
  quill_client_Wqv6ADGlry,
  swiper_client_uDPQhOjmYM,
  toast_client_5GxzM6P4QL,
  vue_query_JC9gnf7CA1,
  wasLoggedIn_client_M31qqvBN1l
]